import type { Dispatch } from 'react';

import { resolveRowIndex, type DraftEntry } from './state/loggerDraftTypes';
import type { LoggerAction } from './state/loggerDraftTypes';

// LG-67 — the timeline row's ✕: the set leaves the feed and goes back to
// pending on its own exercise, re-loggable with every typed value intact.
// Extracted from useTimelineLogger to keep that hook under the 500-line cap,
// the same split useSetCountHandlers/useFailHandlers came from (LG-14).
//
// No React: it is a dispatch address resolver, and keeping it a plain factory
// means the entry-identity rule below is testable without mounting anything.
//
// ⭐ Resolved by IDENTITY, never by a row index carried down from the render —
// the rule focusRow already follows, and the one PE-22 F had to be repaired
// after it reopened the wrong exercise in silence
// ([[feedback_no_denormalized_display_snapshots]]). A stale id finds nothing
// and the tap does nothing, which is the right answer to "un-complete a set on
// an exercise that is no longer here".
//
// ⛔ It deliberately does NOT stop the rest countdown, and does NOT move the
// focus. The rest was armed by a completion that really did happen a moment
// ago: the athlete correcting WHERE it was recorded is still resting, and
// killing their clock would cost them the very thing the ✕ is meant to save.
// And the row leaving the feed IS the feedback — yanking the card somewhere
// they did not ask to be is what
// [[feedback_information_goes_where_it_already_has_a_home]] warns against.
export function makeUncompleteSet(
  entries: readonly DraftEntry[],
  dispatch: Dispatch<LoggerAction>,
) {
  return (entryId: string, setIdx: number) => {
    const entryIdx = resolveRowIndex(entries, entryId);
    if (entryIdx < 0) return;
    dispatch({ type: 'uncomplete_set', entryIdx, setIdx });
  };
}
